import { Form } from 'antd'
import { ButtonCommon, ModalCommon, RequireTag } from '../../../components'
import styles from './index.module.scss'
import { InputPasswordCommon } from '../../../components/Input/Password'
import { regex } from '../../../until'
import { usePostProfile } from '../../../hooks/query/user'
import { openNotificationWithIcon } from '../../../hooks'
import { useTranslation } from 'react-i18next'
interface IProps {
  visible: boolean
  onOk: () => void
  onCancel: () => void
}

export const PasswordModal = ({ visible, onOk, onCancel }: IProps) => {
  const { mutateAsync, isLoading } = usePostProfile()
  const {t} = useTranslation()
  const handleFinish = async (values: any) => {
    try {
      await mutateAsync(values)
      openNotificationWithIcon('success', '', t('profile.message.updateSuccess'))
      onOk()
    } catch (error: any) {
      openNotificationWithIcon('error', '', error?.message)
    }
  }

  return (
    <ModalCommon
      destroyOnClose={true}
      title={t('profile.changePassword')}
      visible={visible}
      width="29%"
      className={styles.modal}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Form onFinish={handleFinish} className={styles.form} layout="vertical">
        <div className={styles.form__wrap}>
          <Form.Item
            validateTrigger="onSubmit"
            label={
              <>
                {t('profile.currentPassword')}
                <RequireTag />
              </>
            }
            name="current_password"
            className={styles.form__item}
            rules={[
              {
                required: true,
                message: `${t('profile.message.requireCurrentPwd')}`,
              },
            ]}
          >
            <InputPasswordCommon placeholder={t('profile.message.placeholderInput')} />
          </Form.Item>
          <Form.Item
            validateTrigger="onSubmit"
            label={
              <>
                {t('profile.newPassword')}
                <RequireTag />
              </>
            }
            name="password"
            dependencies={['current_password']}
            className={styles.form__item}
            rules={[
              {
                required: true,
                message: `${t('profile.message.newPwd')}`,
              },
              {
                pattern: regex.validatePassword,
                message: <span style={{ whiteSpace: 'break-spaces' }}>{t('profile.message.ruleNewPassword')}</span>,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value && getFieldValue('current_password') === value) {
                    return Promise.reject(`${t('profile.message.mathCurrentPass')}`)
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <InputPasswordCommon placeholder={t('profile.message.placeholderInput')} />
          </Form.Item>
          <Form.Item
            validateTrigger="onSubmit"
            label={
              <>
                {t('profile.confirmPassword')}
                <RequireTag />
              </>
            }
            name="confirmPassword"
            className={styles.form__item}
            dependencies={['password']}
            rules={[
              {
                required: true,
                message: `${t('profile.message.confirmPassword')}`,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(`${t('profile.message.confirmPwdNotMatch')}`)
                },
              }),
            ]}
          >
            <InputPasswordCommon placeholder={t('profile.message.placeholderInput')} />
          </Form.Item>
        </div>
        <div className={styles.form__btn__wrap}>
          <ButtonCommon type="ghost" onClick={onCancel}>
            {t('profile.cancel')}
          </ButtonCommon>
          <ButtonCommon loading={isLoading} type="primary" htmlType="submit">
            {t('profile.savePassword')}
          </ButtonCommon>
        </div>
      </Form>
    </ModalCommon>
  )
}
